import type { PrimitiveType, PrimitiveTypeName } from '#layers/data-model/types/schema/primitive-type';
import { getTypename, isPrimitiveTypeDateTime, isPrimitiveTypeNumber } from '#layers/data-model/utils/schema/primitive-type';

export function getPrimitiveTypeIcon(type: PrimitiveType | PrimitiveTypeName) {
	const typename = getTypename(type);

	if (isPrimitiveTypeNumber(typename)) {
		return 'lucide:hash';
	}
	else if (typename === 'boolean') {
		return 'lucide:toggle-left';
	}
	else if (typename === 'string' || typename === 'uuid') {
		return 'lucide:type';
	}
	else if (typename === 'json') {
		return 'lucide:braces';
	}
	else if (typename === 'bytes') {
		return 'lucide:binary';
	}
	else if (typename === 'geometry') {
		return 'lucide:map';
	}
	else if (isPrimitiveTypeDateTime(typename) || typename === 'time') {
		return 'lucide:clock-4';
	}
	else if (typename === 'date') {
		return 'lucide:calendar-1';
	}
	else if (typename === 'unsupported') {
		return 'lucide:alert-triangle';
	}
}
